// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-info {
  padding: 0 0 12px 0;
}

.chart-info p {
  margin: 0;
}

ngx-charts-line-chart,
.chart-empty-state {
  display: block;
  max-width: 100%;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/charts/graphs/sem-line-graph/sem-line-graph.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".chart-info {\r\n  padding: 0 0 12px 0;\r\n}\r\n\r\n.chart-info p {\r\n  margin: 0;\r\n}\r\n\r\nngx-charts-line-chart,\r\n.chart-empty-state {\r\n  display: block;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
